export const getProcessItemPriceTree = (params) => {
  return window._this.$http.get(`/go/admin/salary/process_item_price_ass`, {
    params,
  });
};

// 岗位人员配置 列表
export const getPositionStaffingList = (params) => {
  return window._this.$http.get(`/go/admin/salary/position_config`, {
    params,
  });
};

// 导入岗位人员配置
export const uploadPositionStaffingList = (params) => {
  return window._this.$http.post(`/go/admin/salary/position_config`, params, {
    responseType: "arraybuffer",
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
// 在明细新增岗位
export const addPosition = (params) => {
  return window._this.$http.post(
    `/go/admin/salary/position_config_detail`,
    params
  );
};

// 岗位操作日志
export const getPositionOperatingLog = (params) => {
  return window._this.$http.get(`/go/admin/salary/operation_log`, {
    params,
  });
};

// 岗位明细
export const getPositionOperatingDetail = (params) => {
  return window._this.$http.get(`/go/admin/salary/position_config_detail`, {
    params,
  });
};
// 设置不计薪时间
export const setPieceDisabledPeriod = (params) => {
  return window._this.$http.put(
    `/go/admin/salary/position_config_detail`,
    params
  );
};

// 在明细删除岗位
export const deletePosition = (data) => {
  return window._this.$http.delete(`/go/admin/salary/position_config_detail`, {
    data,
    headers: {
      "Content-Type": "application/json",
    },
  });
};
// 薪资核算汇总表
export const getSalaryAccountingSummary = (params) => {
  return window._this.$http.get(
    `/go/admin/salary/workload_statistics_summary`,
    {
      params,
    }
  );
};
// 薪资核算明细
export const getSalaryAccountingSummaryDetail = (params) => {
  return window._this.$http.get(`/go/admin/salary/workload_statistics`, {
    params,
  });
};
// 薪资重新核算
export const recalculateSalary = (params) => {
  return window._this.$http.put(`/go/admin/salary/workload_statistics`, params);
};
// 更新工序状态
export const changeProcessStatus = (data) => {
  return window._this.$http.put(
    `/go/admin/salary/process_item/${data.process_item_id}`,
    data
  );
};
// 添加岗位用到的岗位列表
export const getPositionList = (params) => {
  return window._this.$http.get(`/go/admin/salary/process_item`, {
    params,
  });
};

// 重新核算用到的岗位列表
export const getPositionListForRecheck = (params) => {
  return window._this.$http.get(`/go/admin/salary/allocate_processes`, {
    params,
  });
};
// 批量修改价格
export const updateProcessPrices = (params) => {
  return window._this.$http.put(`/go/admin/salary/process_item_price`, params, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};



// WEBPACK FOOTER //
// ./src/api/salary.js